<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                // this.$store.commit('updateField', {
                //     key: 'basicInfo.countryOfResidence',
                //     value: selectedItem.title,
                // })
                

                if (this.field.key === 'basicInfo.countryOfResidenceId') {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.countryOfResidence',
                        value: selectedItem.title,
                    })
                    if (selectedItem.dataSegmentId == process.env.VUE_APP_RC_ACCOUNT) {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.country',
                            value: selectedItem.value,
                        })
                    }
                }
                if (this.field.key === 'fatcaInfo.countryOfResidenceId') {
                    this.$store.commit('updateField', {
                        key: 'fatcaInfo.countryOfResidence',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'fatcaInfo.countryOfIncorpId') {
                    this.$store.commit('updateField', {
                        key: 'fatcaInfo.countryOfIncorp',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'fatcaInfo.CountryResident') {
                    this.$store.commit('updateField', {
                        key: 'fatcaInfo.CountryResidentTitle',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'fatcaInfo.dualNationalCountry') {
                    this.$store.commit('updateField', {
                        key: 'fatcaInfo.dualNationalCountryTitle',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'fatcaInfo.CountryTax') {
                    this.$store.commit('updateField', {
                        key: 'fatcaInfo.CountryTaxTitle',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'crsInfo.crsCountryTax1') {
                    this.$store.commit('updateField', {
                        key: 'crsInfo.crsCountryTaxTitle1',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'crsInfo.crsCountryTax2') {
                    this.$store.commit('updateField', {
                        key: 'crsInfo.crsCountryTaxTitle2',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'crsInfo.crsCountryTax3') {
                    this.$store.commit('updateField', {
                        key: 'crsInfo.crsCountryTaxTitle3',
                        value: selectedItem.title,
                    })
                }
                // console.log("selected title ",selectedItem.title)

                this.$store.commit('setValue', {
                    key: 'isTaxIdRequired',
                    value: selectedItem.taxIdRequired,
                })
                this.$store.commit('setValue', {
                    key: 'isTaxIdMandatory',
                    value: selectedItem.isTaxIdMandatory,
                })
                this.$store.commit('setValue', {
                    key: 'taxIdNote',
                    value: selectedItem.taxIdNote,
                })
            }
        },
    }, // End of Component > watch
}
</script>
